<nav class="navbar navbar-expand-sm navbar-light At-Navbar">
  <a class="navbar-brand At-BrandHolder"  routerLink="/dashboard">
    <div class=" d-flex align-items-center">
      <figure>
        <i class="icon-logo"></i>
      </figure>
      <h4>Komunikasi</h4>
    </div>
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <div class="At-TopSearch">
      <i class="icon-search"></i>
      <input class="form-control At-NoBorder" type="search" placeholder="Search ..." aria-label="Search">
    </div>
    <ul class="navbar-nav m-auto At-NavbarNavCenter">
      <li class="nav-item active" (click)="onClick(1)"   [ngClass]="{'active': tab==='tab1'}">
        <a class="nav-link" routerLink="/dashboard"><i class="icon-home"></i> Home</a>
      </li>
      <li class="nav-item" (click)="onClick(2)"   [ngClass]="{'active': tab==='tab2'}">
        <a class="nav-link" routerLink="/dashboard/messages"><i class="icon-chat"></i>Messages</a>
      </li>
      <li class="nav-item" (click)="onClick(3)"   [ngClass]="{'active': tab==='tab3'}">
        <a class="nav-link" routerLink="/dashboard/no-channel"><i class="icon-channel"></i>Channels</a>
      </li>
    </ul>

    <ul class="navbar-nav At-NavbarNavRight d-flex align-items-center justify-content-end">
      <li class="nav-item dropdown At-profile At-Dropdown At-DropdownBox" dropdown>
        <button id="button-basic2" dropdownToggle type="button" class="nav-link At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic2">
        <div class="At-ImgWrap">
          <figure>
            <img src="assets/images/profile/profile-header.png" class="img-fluid" alt="">
          </figure>
        </div>
        <div class="At-ImgText">
          <h6>Micheal Dcosta </h6>
          <p><i class="circal"></i>  Active Now</p>
        </div>
        </button>
        <ul id="dropdown-basic2" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic2">
          <li role="menuitem"><a href="#" routerLink="/dashboard/profile"> <i class="icon-profile"></i> my profile</a></li>
          <li role="menuitem"><a href="#" routerLink="/dashboard/profile"> <i class="icon-gallery"></i> media</a></li>
          <li role="menuitem"><a href="#" routerLink="/dashboard/profile"> <i class="icon-users"></i> my contacts</a></li>
        </ul>
      </li>
      <li class="nav-item At-Notification At-DropdownBox" dropdown>
        <button id="button-basic3" dropdownToggle type="button" class="nav-link At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic3">
          <i class="circal"></i>
          <i class="icon-notification"></i>
        </button>
         <ul id="dropdown-basic3" *dropdownMenu class="dropdown-menu At-CustomScroll" role="menu" aria-labelledby="button-basic3">
          <li role="menuitem" class="At-Header"><h5>notification</h5></li>
          <li role="menuitem" class="At-heading"><h6>new</h6></li>
          <li role="menuitem" class="At-BgColorChange">
              <a href="#" routerLink="/dashboard/notifications">
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure><img src="assets/images/members/member-img09.png" alt="" class="img-fluid"></figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Aiman <span class="At-TextDarkGrey2">posted a new photo </span></h5>
                        <h6>6 hours ago</h6>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li role="menuitem" class="At-BgColorChange">
              <a href="#" routerLink="/dashboard/notifications">
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure>
                      <img src="assets/images/members/member-img01.png" alt="" class="img-fluid">
                      <div class="At-badgePurple"><i class="icon-bage"></i></div>
                    </figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Julian <span class="At-TextDarkGrey2">invited you to join channel <strong>“Software Development Team”</strong></span></h5>
                        <h6>14 hours ago</h6>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li role="menuitem" class="At-BgColorChange">
              <a href="#" routerLink="/dashboard/notifications">
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure><img src="assets/images/profile/profile-small3.png" alt="" class="img-fluid"></figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Ainita <span class="At-TextDarkGrey2">send you a follow request</span></h5>
                        <h6>14 hours ago</h6>
                    </div>
                    <div class="At-BtnArea">
                      <Button class="mr-4">Accept</Button>
                      <Button class="At-BgRed">Decline</Button>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li role="menuitem" class="At-heading"><h6>others</h6></li>
            <li role="menuitem" class="">
              <a href="#" routerLink="/dashboard/notifications">
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure><img src="assets/images/members/member-img03.png" alt="" class="img-fluid"></figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Jacob <span class="At-TextDarkGrey2">commented on your post “It feels like just yesterday that we have met  :( ” </span></h5>
                        <h6>22 hours ago</h6>
                    </div>
                    <div class="At-TitleRight">
                      <div class="At-InfoImg">
                        <figure><img src="assets/images/posts/post-img7.png" alt="" class="img-fluid"></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li role="menuitem" class="">
              <a href="#" routerLink="/dashboard/notifications">
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure>
                      <img src="assets/images/members/member-img05.png" alt="" class="img-fluid">
                      <div class="At-badgePurple"><i class="icon-bage"></i></div>
                    </figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Anatoli <span class="At-TextDarkGrey2">accepted your follow request</span></h5>
                        <h6>1 day ago</h6>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li role="menuitem" class="">
              <a href="#" routerLink="/dashboard/notifications">
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure><img src="assets/images/members/member-img02.png" alt="" class="img-fluid"></figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Micheal <span class="At-TextDarkGrey2">commented on your post “Don’t forget to bring a hoodie for me ”</span></h5>
                        <h6>1 day ago</h6>
                    </div>
                    <div class="At-TitleRight">
                      <div class="At-InfoImg">
                        <figure><img src="assets/images/posts/post-img8.png" alt="" class="img-fluid"></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li role="menuitem" class="">
              <a href="#" routerLink="/dashboard/notifications">
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure><img src="assets/images/members/member-img10.png" alt="" class="img-fluid"></figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Jacob <span class="At-TextDarkGrey2">and 2 others liked your post</span></h5>
                        <h6>1 day ago</h6>
                    </div>
                    <div class="At-TitleRight">
                      <div class="At-InfoImg">
                        <figure><img src="assets/images/posts/post-img9.png" alt="" class="img-fluid"></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li role="menuitem" class="">
              <a href="#" routerLink="/dashboard/notifications">
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure><img src="assets/images/members/member-img04.png" alt="" class="img-fluid"></figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Softpetal:) <span class="At-TextDarkGrey2">liked your comment “The place looks beautiful:) ”</span></h5>
                        <h6>1 day ago</h6>
                    </div>
                    <div class="At-TitleRight">
                      <div class="At-InfoImg">
                        <figure><img src="assets/images/posts/post-img10.png" alt="" class="img-fluid"></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
        </ul>
      </li>
      <li class="nav-item At-Settings At-DropdownBox" dropdown>
        <button id="button-basic4" dropdownToggle type="button" class="nav-link At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic4">
          <i class="icon-setting"></i>
        </button>
         <ul id="dropdown-basic4" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic4">
          <li role="menuitem" class="At-Header"><h5>Settings</h5></li>
          <li role="menuitem"><a href="#" routerLink="/dashboard/settings"> <i class="icon-notification"></i> notifications</a></li>
          <li role="menuitem"><a href="#" routerLink="/dashboard/settings"> <i class="icon-lock"></i> privacy</a></li>
          <li role="menuitem"><a href="#" routerLink="/dashboard/settings"> <i class="icon-language"></i> language</a></li>
          <li role="menuitem"><a href="#" routerLink="/dashboard/settings"> <i class="icon-question-mark"></i> help</a></li>
          <li role="menuitem"><a href="#" routerLink="/dashboard/settings"> <i class="icon-bage"></i> upgrade to vip subscription</a></li>
        </ul>
      </li>
    </ul>

  </div>
</nav>
